<div class="btn-group cliente-analise-financeira-btn-options">
    <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="far fa-clipboard"></i> <span class="d-none d-sm-inline-block ml-2">Análise Financeira</span>
    </button>
    <div class="dropdown-menu">
        <!-- Iniciar -->
        <a class="dropdown-item dropdown-item-primary" #dropdownItemIniciar *ngIf="config?.canIniciar" (click)="iniciar()">
            <i class="fas fa-play"></i> Iniciar
        </a>
        
        <!-- Cancelar Iniciar -->
        <ng-template [ngIf]="config?.canCancelarIniciar">
            <a class="dropdown-item dropdown-item-delete" #dropdownItemCancelarIniciar (click)="cancelarIniciar()">
                <i class="fas fa-ban"></i> Cancelar Inicio
            </a>     
            <div class="dropdown-divider"></div>
        </ng-template>

        <!-- Concluir -->
        <a class="dropdown-item dropdown-item-success" *ngIf="config?.canConcluir" (click)="concluir.emit()">
            <i class="fas fa-check"></i> Concluir
        </a>

        <!-- Cancelar Concluir -->
        <ng-template [ngIf]="config?.canCancelarConcluir">
            <a class="dropdown-item dropdown-item-delete" #dropdownItemCancelarConcluir (click)="cancelarConcluir()">
                <i class="fas fa-ban"></i> Cancelar Conclusão
            </a>     
            <div class="dropdown-divider"></div>
        </ng-template>  
        
        <!-- Revisar -->
        <a class="dropdown-item" *ngIf="config?.canRevisar" (click)="revisar.emit()">
            <i class="far fa-edit"></i> Revisar
        </a>        
    </div>
</div>  